import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtTouchableEffect from "../../../components/NtTouchableEffect";
import { useNavigation } from "@react-navigation/native";
import { useMobile } from "../../../hooks/useMobile";

function NtMarketingLogo({ containerStyle, onPress }) {
  const nav = useNavigation();
  const isMobile = useMobile();
  return (
    <NtTouchableEffect
      style={[styles.container, containerStyle]}
      onPress={onPress}
    >
      <Image
        style={{
          width: isMobile ? 120 : 180,
          height: isMobile ? 40 : 60,
          resizeMode: "contain",
        }}
        source={require("../../../assets/images/nt-connect-white.png")}
      />
    </NtTouchableEffect>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default NtMarketingLogo;
